
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, CardHeader, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import CustomPagination from '../../Components/Common/CustomPagination';
import { OrderAPI } from '../../helpers/firebase_helper';


const Invoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const invoicesPerPage = 5;

  const profileData = useSelector((state) => state.Profile.profileData);
  const navigate = useNavigate();

 
  const cognito_id = profileData?.result?.cognito_id;
  const token = localStorage.getItem('token');  

  const fetchInvoices = async () => {
    if (!cognito_id) {
      console.error('Cognito ID is missing.');
      return;
    }
  

    setLoading(true);
    try {
      const response = await OrderAPI.fetchInvoice(cognito_id);
      
      const sortedInvoices = (response?.result || []).sort((a, b) => b.invoice_id - a.invoice_id);

      setInvoices(sortedInvoices);
     
      
      toast.success('Invoices loaded successfully!');
    } catch (error) {
      console.error('Error fetching invoices:', error);
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cognito_id) {
      fetchInvoices();
    }
  }, [cognito_id]);

  
  const indexOfLastInvoice = currentPage * invoicesPerPage;
  const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
  const currentInvoices = invoices.slice(indexOfFirstInvoice, indexOfLastInvoice);

  const handlePageChange = (page) => setCurrentPage(page);


  const handleView = (Url) => {
    window.open(Url, '_blank');
  };




  const handleDownload = async (url) => {
    try {
      const response = await axios.get(url, {
        responseType: "blob", 
        headers: {
          'Content-Type': 'application/pdf'  
        }
      });

      const blob = new Blob([response]);
      const downloadUrl = window.URL.createObjectURL(blob);
    
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = url.split("/").pop(); 
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download the file.");
    }
  };


  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Invoices" pageTitle="Billing" />
        <Row>
          <Col>
            <Card>
              <CardHeader className="align-items-center">
                <Row>
                  <h4 className="card-title mb-0 flex-grow-1">Invoice History</h4>
                </Row>
              </CardHeader>

              <CardBody>
                {loading ? (
                  <div className="text-center">Loading...</div>
                ) : (
                  <div className="table-responsive table-card">
                    <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                      <thead className="text-muted table-light">
                        <tr>
                          <th>Invoice </th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentInvoices.length > 0 ? (
                          currentInvoices.map((invoice) => (
                            <tr key={invoice.invoice_id}>
                              <td>{invoice.invoice_id}</td>
                              <td>{invoice.date}</td>
                              <td>{invoice.amount}</td>
                              <td>
                                <Button color="primary" size="sm" onClick={() => handleView(invoice.url)} className='me-3'>
                                  View
                                </Button>
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() => handleDownload(invoice.url)}
                                >
                                  Download
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No invoices found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>

         
          <div className="row g-0 text-center text-sm-start align-items-center mb-3">
            <div className="col-sm-6">
              <p className="mb-sm-0 ms-3">
                Showing {indexOfFirstInvoice + 1} to {Math.min(indexOfLastInvoice, invoices.length)} of {invoices.length} entries
              </p>
            </div>
            <div className="col-sm-6">
              <ul className="pagination pagination-separated justify-content-center justify-content-sm-end mb-sm-0 me-3">
                <CustomPagination
                  currentPage={currentPage}
                  totalItems={invoices.length}
                  itemsPerPage={invoicesPerPage}
                  onPageChange={handlePageChange}
                />
              </ul>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Invoices;

